/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Bank131ApiDomainBank131ConstantsBank131ApiTypeFromJSON, Bank131ApiDomainBank131ConstantsBank131ApiTypeToJSON, } from './Bank131ApiDomainBank131ConstantsBank131ApiType';
/**
 * Check if a given object implements the FxIdWebFeaturesStoreBank131PaymentFormDataBank131PaymentFormResultBank131Info interface.
 */
export function instanceOfFxIdWebFeaturesStoreBank131PaymentFormDataBank131PaymentFormResultBank131Info(value) {
    if (!('DemoMode' in value) || value['DemoMode'] === undefined)
        return false;
    if (!('ApiType' in value) || value['ApiType'] === undefined)
        return false;
    if (!('GameCode' in value) || value['GameCode'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesStoreBank131PaymentFormDataBank131PaymentFormResultBank131InfoFromJSON(json) {
    return FxIdWebFeaturesStoreBank131PaymentFormDataBank131PaymentFormResultBank131InfoFromJSONTyped(json, false);
}
export function FxIdWebFeaturesStoreBank131PaymentFormDataBank131PaymentFormResultBank131InfoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'DemoMode': json['DemoMode'],
        'ApiType': Bank131ApiDomainBank131ConstantsBank131ApiTypeFromJSON(json['ApiType']),
        'GameCode': json['GameCode'],
    };
}
export function FxIdWebFeaturesStoreBank131PaymentFormDataBank131PaymentFormResultBank131InfoToJSON(json) {
    return FxIdWebFeaturesStoreBank131PaymentFormDataBank131PaymentFormResultBank131InfoToJSONTyped(json, false);
}
export function FxIdWebFeaturesStoreBank131PaymentFormDataBank131PaymentFormResultBank131InfoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'DemoMode': value['DemoMode'],
        'ApiType': Bank131ApiDomainBank131ConstantsBank131ApiTypeToJSON(value['ApiType']),
        'GameCode': value['GameCode'],
    };
}
//# sourceMappingURL=FxIdWebFeaturesStoreBank131PaymentFormDataBank131PaymentFormResultBank131Info.js.map